/* eslint no-console: 0 */
import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {
    findSession,
    findUser,
    approveSession,
    reassignSession,
    cancelFundedSpot,
    refundSession,
    changeSessionContractId,
    changeSessionValidUntil,
    unarchiveSession,
    deleteUser,
    toggleTester,
    changeProgram
} from 'actions/paywallActions';
import UserPanel from './userPanel';
import './search.scss';
import ref from 'services/firebaseRef';
import {publishEvent} from "services/events";
import programs from "../../../programs";
import SessionList from 'views/staff/sessionList'
import SessionPanel from 'views/staff/sessionPanel'

function getProfile(user) {
  const { profile, ...rest } = user;
  return {
    ...rest,
    ...profile
  }
}

class Search extends Component {

  static propTypes = {
    history: PropTypes.object.isRequired,
    route: PropTypes.object.isRequired,
    routeParams: PropTypes.object.isRequired,
    paywall: PropTypes.object.isRequired,
    findSession: PropTypes.func.isRequired,
    findUser: PropTypes.func.isRequired,
    approveSession: PropTypes.func.isRequired,
    reassignSession: PropTypes.func.isRequired,
    cancelFundedSpot: PropTypes.func.isRequired,
    refundSession: PropTypes.func.isRequired,
    changeSessionContractId: PropTypes.func.isRequired,
    changeSessionValidUntil: PropTypes.func.isRequired,
    unarchiveSession: PropTypes.func.isRequired,
    deleteUser: PropTypes.func.isRequired,
    toggleTester: PropTypes.func.isRequired,
    changeProgram: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount () {
    this._loadFromRoute();
  }

  componentDidUpdate (prevProps) {
    const {route} = this.props;
    if (prevProps.route.path !== route.path) {
      this._loadFromRoute();
    }
  }

  _loadFromRoute() {
    const {route, routeParams} = this.props;
    const path = route.path || '';
    if (path.startsWith('session/')) {
      this.props.findSession(routeParams.sessionId);
    }
    else if (path.startsWith('user/')) {
      this.props.findUser(routeParams.userId);
    }
    else {
      this.props.findSession('');
    }
  }

  handleSessionIdChange(evt) {
    this.setState({sessionId: evt.target.value, message: ''});
  }

  findSession(evt) {
    evt.stopPropagation();
    evt.preventDefault();
    if (!this.state.sessionId) {
      return;
    }
    this.props.history.push('/staff/session/' + this.state.sessionId);
  }

  handleUserIdChange(evt) {
    this.setState({userId: evt.target.value, message: ''});
  }

  findUser(evt) {
    evt.stopPropagation();
    evt.preventDefault();
    if (!this.state.userId) {
      return;
    }
    this.props.history.push('/staff/user/' + this.state.userId);
  }

  _checkUserExists(userId) {
    return new Promise((resolve, reject) => {
      ref.child('users').child(userId)
          .on('value', snapshot => {
            if (!snapshot || !snapshot.val()) {
              return reject(new Error('User ID doesn\'t exist.'));
            }
            resolve();
          }, reject);
    });
  }

  handleChangeUser({sessionId, programId, oldUserId, newUserId, staffUserId}) {
    const {funding, contractId, language} = this.props.paywall.sessionFound.session;
    const reassignSessionArgs = {
      sessionId,
      programId,
      oldUserId,
      newUserId,
      staffUserId,
      funding,
      contractId,
      language
    };
    return this._checkUserExists(newUserId)
        .then(() => this.props.reassignSession(reassignSessionArgs))
        .then(() => this.props.findSession(''))
        .then(() => this.setState({message: `User changed for session  ${sessionId}`}));
  }

  handleCancelFundedSpot({sessionId, programId, userId, staffUserId}) {
    this.props.cancelFundedSpot(sessionId, programId, userId, staffUserId)
        .then(() => this.props.findSession(''))
        .then(() => this.setState({message: `Funded spot cancelled for session ${sessionId}`}));
  }

  handleRefundSession ({sessionId, sessionFunding, programId, userId, staffUserId}) {
    this.props.refundSession(sessionId, sessionFunding, programId, userId, staffUserId)
        .then(() => this.props.findSession(''))
        .then(() => this.setState({message: `Session marked as refunded ${sessionId}`}));
  }

  handleChangeContractId ({sessionId, programId, userId, staffUserId, oldContractId, newContractId}) {
    this.props.changeSessionContractId(sessionId, programId, userId, staffUserId, oldContractId, newContractId)
        .then(() => this.props.findSession(''))
        .then(() => this.setState({message: `Session ${sessionId} contract id changed to ${newContractId}`}));
  }

  handleChangeValidUntil({sessionId, programId, userId, staffUserId, oldValidUntil, newValidUntil}) {
    this.props.changeSessionValidUntil(sessionId, programId, userId, staffUserId, oldValidUntil, newValidUntil)
        .then(() => this.props.findSession(''))
        .then(() => this.setState({message: `Session ${sessionId} valid Until changed to ${moment(newValidUntil).local().toString()}`}));
  }

  handleApproveSession(args) {
    const {sessionId} = args;
    this.props.approveSession(args)
      .then(() => this.props.findSession(''))
      .then(() => this.setState({message: `Session ${sessionId} is approved.`}));
  }

  handleUnarchiveSession({sessionId, programId, userId, staffUserId}) {
    this.props.unarchiveSession({sessionId, programId, userId, staffUserId})
      .then(() => this.props.findSession(''))
      .then(() => this.setState({message: `Session ${sessionId} is unarchived.`}));
  }

  handleHideSession(args) {
    this.props.hideSession(args)
      .then(() => this.props.findSession(''))
      .then(() => this.setState({message: `Session ${args.sessionId} is hidden.`}));
  }

  handleDeleteUser({userId, staffUserId}) {
    this.props.deleteUser({userId, staffUserId})
      .then(() => this.props.findSession(''))
      .then(() => this.setState({message: `User ${userId} is deleted.`}));
  }

  handleToggleTester({userId, staffUserId, tester}) {
    this.props.toggleTester({userId, staffUserId, tester})
      .then(() => this.setState({message: `User ${userId} is ${tester ? 'now' : 'no longer'} a beta tester.`}));
  }

  handleAddToNurtureCampaign(args) {
    publishEvent(`Class Approved Nurture Campaign Started`, args);
    this.props.findSession('')
      .then(() => this.setState({message: `Session ${args.sessionId} nurture campaign started event sent.`}));
  }

  handleChangeProgram(args) {
    const newProgramTitle = programs.programLookup[args.newProgramId].title;
    this.props.changeProgram(args)
      .then(() => this.props.findSession(''))
      .then(() => this.setState({message: `Session ${args.sessionId} program changed to ${newProgramTitle}.`}))
  }

  handlePutOnHold() {}

  clearFound() {
    this.props.history.replace('/staff');
  }

  render() {
    const {paywall} = this.props;
    return (
      <div>
        <div className="row">
          <div className="col-sm-12">
            <span>{this.state.message}</span>
          </div>
        </div>
        {paywall.sessionFound &&
        <UserPanel
          profile={getProfile(paywall.sessionFound.user)}
          userId={paywall.sessionFound.user.userId}
          clearFound={::this.clearFound}
        >
          <div>
            <h4>Session</h4>
            <SessionPanel
              session={paywall.sessionFound.session}
              userId={paywall.sessionFound.user.userId}
              email={paywall.sessionFound.user.profile.email}
              approveSession={::this.handleApproveSession}
              cancelFundedSpot={::this.handleCancelFundedSpot}
              changeUser={::this.handleChangeUser}
              clearFound={::this.clearFound}
              refundSession={::this.handleRefundSession}
              changeContractId={::this.handleChangeContractId}
              changeValidUntil={::this.handleChangeValidUntil}
              unarchiveSession={::this.handleUnarchiveSession}
              addToNurtureCampaign={::this.handleAddToNurtureCampaign}
              putOnHold={::this.handlePutOnHold}
              changeProgram={::this.handleChangeProgram}
            />
          </div>
        </UserPanel>
        }
        {paywall.userFound &&
        <UserPanel
          profile={getProfile(paywall.userFound)}
          userId={paywall.userFound.userId}
          deleteUser={::this.handleDeleteUser}
          toggleTester={::this.handleToggleTester}
          clearFound={::this.clearFound}
        >
          <SessionList
            title={"Sessions"}
            userId={paywall.userFound.userId}
            email={paywall.userFound.profile.email}
            sessions={paywall.userFound.sessions}
            approveSession={::this.handleApproveSession}
            putOnHold={::this.handlePutOnHold}
            changeProgram={::this.handleChangeProgram}
            changeUser={::this.handleChangeUser}
            cancelFundedSpot={::this.handleCancelFundedSpot}
            clearFound={::this.clearFound}
            refundSession={::this.handleRefundSession}
            changeContractId={::this.handleChangeContractId}
            changeValidUntil={::this.handleChangeValidUntil}
            unarchiveSession={::this.handleUnarchiveSession}
            addToNurtureCampaign={::this.handleAddToNurtureCampaign}
          />
        </UserPanel>
        }
        {!paywall.sessionFound && !paywall.userFound &&
        <form action="#" className="sessionFinder">
          <div className="well form-horizontal clearfix">
            <div className="col-sm-6">
              <div className="form-group">
                <label className="col-xs-2 col-sm-4 control-label">Session Id</label>
                <div className="col-xs-10 col-sm-8">
                  <input className="form-control"
                         type="text"
                         placeholder="sessionId"
                         onBlur={::this.handleSessionIdChange}/>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <button
                className="btn btn-primary btn-sm"
                onClick={::this.findSession}>
                Search
              </button>
            </div>
          </div>
        </form>
        }
        {!paywall.sessionFound && !paywall.userFound &&
        <form action="#" className="userFinder">
          <div className="well form-horizontal clearfix">
            <div className="col-sm-6">
              <div className="form-group">
                <label className="col-xs-2 col-sm-4 control-label">User Id</label>
                <div className="col-xs-10 col-sm-8">
                  <input className="form-control"
                         type="text"
                         placeholder="userId"
                         onBlur={::this.handleUserIdChange}/>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <button
                className="btn btn-primary btn-sm"
                onClick={::this.findUser}>
                Search
              </button>
            </div>
          </div>
        </form>
        }
      </div>
    );
  }
}

export default connect(
  state => {
    const {paywall} = state;
    return {paywall};
  },
  {
    findSession,
    findUser,
    approveSession,
    reassignSession,
    cancelFundedSpot,
    refundSession,
    changeSessionContractId,
    changeSessionValidUntil,
    unarchiveSession,
    deleteUser,
    toggleTester,
    changeProgram
  }
)(Search);



// WEBPACK FOOTER //
// ./src/views/staff/search.jsx